import firebase from 'firebase';
import "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBUJztAxNpDAxCnRVXYYMx6HkUipKCTc6g",
  authDomain: "kosmos-90e4e.firebaseapp.com",
  projectId: "kosmos-90e4e",
  storageBucket: "kosmos-90e4e.appspot.com",
  messagingSenderId: "510545061171",
  appId: "1:510545061171:web:456aae43a2af64c59f4a46",
  measurementId: "G-E4E4GF07F0"
  };
  // Initialize Firebase
  const firebaseApp= firebase.initializeApp(firebaseConfig);
  const db= firebaseApp.firestore();
  const storage= firebase.storage();

  export{storage,db, firebase as default};